import { GTMConfig } from './../interfaces/GTM';
import TokenService from '../services/Token';

//Se carga la sesión desde el interceptor y se forma el ID utilizando los token bearer y lead:
export const loadGTMSession = async () => {
  const bearerToken = TokenService.getToken();
  const leadToken = TokenService.getLeadToken()?.replace(/%2b/gi, '+');
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Meses empiezan desde 0
  const day = String(date.getDate()).padStart(2, '0'); // Día del mes
  const formattedDate = `${year}${month}${day}`;
  // usrId+_+YYYYMMDD+_+bearer_token
  const sessionID = `${leadToken}_${formattedDate}_${bearerToken}`;

  // console.log('Session ID:', sessionID);
  dataLayerParamAdd('session_id', sessionID);
};

// Tags
export const dataLayerParamAdd = (data: any, value: any) => {
  const arrayDataLayer = window.dataLayer || [];
  const existingItem = arrayDataLayer.find((item: any) => Object.prototype.hasOwnProperty.call(item, data));
  if (!existingItem || data === 'Payment') {
    // Añade el nuevo tag si no existe
    window.dataLayer.push({ [data]: value });
  } else {
    // Actualiza el valor existente
    existingItem[data] = value;
  }
};

// Events
export const gevent = (name: any, data?: any) => {
  window.dataLayer.push({
    event: name,
    ...data,
  });
};

//env-3 DEV; env-4 PLAY; PROD sin especificar nada
export const gtmEnvConfig: Record<string, GTMConfig> = {
  development: {
    gtmId: 'GTM-NN6FCHZP',
    gtmAuth: '-biRCE5c3Hmm8LOnKOtb1w',
    gtmPreview: 'env-3',
  },
  staging: {
    gtmId: 'GTM-NN6FCHZP',
    gtmAuth: 'ai9qYRere6uCbww2YaMmQg',
    gtmPreview: 'env-4',
  },
  production: {
    gtmId: 'GTM-NN6FCHZP',
    gtmAuth: '',
    gtmPreview: '',
  },
};
